import { useState } from 'react';
import { formatMoney } from '../../../../shared/utility';
import './Filter.scss';

const Filter = ({ search }) => {
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [minMultiplier, setMinMultiplier] = useState(1000);
  const [maxMultiplier, setMaxMultiplier] = useState(1000);
  const [params, setParams] = useState({
    city: '',
    propertyName: '',
    minPrice: '',
    maxPrice: '',
    propertyType: '',
    beds: '',
    baths: '',
    minSize: '',
    maxSize: '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    search(params);
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    setParams((prevProject) => ({
      ...prevProject,
      [name]: type === 'number' ? +value : value,
    }));
  };

  const resetSettings = () => {
    setParams({
      city: '',
      propertyName: '',
      minPrice: '',
      maxPrice: '',
      propertyType: '',
      beds: '',
      baths: '',
      minSize: '',
      maxSize: '',
    });
    setMinMultiplier(1000);
    setMaxMultiplier(1000);
  };

  return (
    <form className="filter form" onSubmit={handleSubmit}>
      <h3 className="title small center">Filter Settings</h3>

      <div className="form__section--field">
        <label>
          <span>Select City</span>
          <select name="city" onChange={handleChange} value={params.city}>
            <option value="">-- Any --</option>
            <option value="Bodrum">Bodrum</option>
            <option value="Bursa">Bursa</option>
            <option value="Istanbul-A">Istanbul Asia</option>
            <option value="Istanbul-E">Istanbul Europe</option>
          </select>
        </label>
      </div>

      <div className="form__section--field">
        <label>
          <span>Property Name</span>
          <input
            type="text"
            name="propertyName"
            onChange={handleChange}
            value={params.propertyName}
          />
        </label>
      </div>

      <div className="form__section--field">
        <div
          className={
            minMultiplier === 1000 ? 'multiplier selected' : 'multiplier'
          }
          onClick={() => setMinMultiplier(1000)}
        >
          K
        </div>
        <div
          className={
            minMultiplier === 1000000 ? 'multiplier selected' : 'multiplier'
          }
          onClick={() => setMinMultiplier(1000000)}
        >
          M
        </div>
        <div
          className={
            maxMultiplier === 1000 ? 'multiplier selected' : 'multiplier'
          }
          onClick={() => setMaxMultiplier(1000)}
        >
          K
        </div>
        <div
          className={
            maxMultiplier === 1000000 ? 'multiplier selected' : 'multiplier'
          }
          onClick={() => setMaxMultiplier(1000000)}
        >
          M
        </div>
      </div>

      <div className="form__section--field">
        <label>
          <span>Min Price - USD</span>
          <input
            type="number"
            name="minPrice"
            onChange={(e) =>
              setParams((prevParams) => ({
                ...prevParams,
                minPrice: +e.target.value * minMultiplier,
              }))
            }
            value={params.minPrice / minMultiplier}
          />
          <span>{formatMoney(params.minPrice)}</span>
        </label>

        <label>
          <span>Max Price - USD</span>
          <input
            type="number"
            name="maxPrice"
            onChange={(e) =>
              setParams((prevParams) => ({
                ...prevParams,
                maxPrice: +e.target.value * maxMultiplier,
              }))
            }
            value={params.maxPrice / maxMultiplier}
          />
          <span>{formatMoney(params.maxPrice)}</span>
        </label>
      </div>

      <div className="form__section--field">
        <label>
          <span>Property Type</span>
          <select
            name="propertyType"
            onChange={handleChange}
            value={params.propertyType}
          >
            <option value="">-- Any --</option>
            <option value="villa">Villa</option>
            <option value="apartment">Apartment</option>
            <option value="residence">Residence</option>
            <option value="office">Office</option>
            <option value="commercial">Commercial</option>
          </select>
        </label>
      </div>

      <div className="line"></div>

      <p
        className="form--advanced"
        onClick={() => setShowAdvanced(!showAdvanced)}
      >
        {showAdvanced ? 'Hide advanced settings' : 'Show advanced settings'}
      </p>

      {showAdvanced && (
        <>
          <p className="form--subtitle">The property should have at least:</p>

          <div className="form__section--field">
            <label>
              <span>Beds</span>
              <input
                type="number"
                min={1}
                name="beds"
                onChange={handleChange}
                value={params.beds}
              />
            </label>

            <label>
              <span>Baths</span>
              <input
                type="number"
                min={1}
                name="baths"
                onChange={handleChange}
                value={params.baths}
              />
            </label>
          </div>

          <div className="form__section--field">
            <label>
              <span>Min Size - sqm</span>
              <input
                type="number"
                name="minSize"
                onChange={handleChange}
                value={params.minSize}
              />
            </label>

            <label>
              <span>Max Size - sqm</span>
              <input
                type="number"
                name="maxSize"
                onChange={handleChange}
                value={params.maxSize}
              />
            </label>
          </div>

          <div className="line"></div>
        </>
      )}

      <button className="btn-b big" type="button" onClick={resetSettings}>
        Reset Settings
      </button>
      <button className="btn-b big active">Search</button>
    </form>
  );
};

export default Filter;
